import { Button } from "reactstrap"
import { useContext, useEffect, useState } from "react"

import AppContext from "AppContext"

import ordemServicoService, { StatusOrdemServicoEnum, TipoHistoricoOrdemServicoEnum, getStatusOrdemServicoDescription } from "services/OrdemServicoService"

import { confirm as conf } from "components/Confirmation"
import { alert } from "components/Alert"
import ModalSelecionarExecutor from "./ModalSelecionarExecutor"
import Registro from "./Registro"
import ModalDetalhes from "../Items/ModalDetalhes"

import './index.scss'
import { compareDate } from "services/Utils"
import { toast } from "react-toastify"
import { showLoading } from "components/Loading"
import { hideLoading } from "components/Loading"
import ModalAtribuirEquipeExecucao from "./ModalAtribuirEquipeExecucao"
import ModalAtribuirEquipeCorrecao from "./ModalAtribuirEquipeCorrecao"
import ModalAlterarPrioridade from "./ModalAlterarPrioridade"
import { TipoContratoEnum } from "services/ContratoService"

const confirm = (text, onConfirm) => {
  conf({
    header: 'Movimentação',
    text,
    icon: 'bi-exclamation-triangle',
    onConfirm
  })
}

export default function Movimentacoes({ idStatus, idOrdemServico, idContrato, valorTotal, itens, os, consorcioEmpresa, onChange }) {
  const [items, setItems] = useState([])
  const [configModalSelecionarExecutor, setConfigModalSelecionarExecutor] = useState()
  const [configModalAtribuirEquipeExecucao, setConfigModalAtribuirEquipeExecucao] = useState()
  const [configModalAtribuirEquipeCorrecao, setConfigModalAtribuirEquipeCorrecao] = useState()
  const [configModalDetalhes, setConfigModalDetalhes] = useState()
  const [configModalAlterarPrioridade, setConfigModalAlterarPrioridade] = useState()
  const { state } = useContext(AppContext)
  const acoesUsuario = state?.user?.acoes || []

  const carregar = () => {
    ordemServicoService.getHistorico(idOrdemServico).then(res => {
      if (res.success) {
        setItems(res.data)
      }
    })
  }

  useEffect(() => {
    carregar()
  }, [idOrdemServico])

  // SDD 037 - mesma janela do backend: antes de a execucao comecar, so contrato NORMAL
  // (a posse do FISCAL/GESTOR_CONTRATO e checada no backend -> 403)
  const podeAlterarPrioridade = !!os &&
    acoesUsuario.includes('os.alterar_prioridade') &&
    os.contrato_tipoContrato == TipoContratoEnum.NORMAL &&
    (
      idStatus == StatusOrdemServicoEnum.PENDENTE ||
      idStatus == StatusOrdemServicoEnum.AGUARDANDO_SELECAO_EMPRESA_EXECUTORA ||
      (idStatus == StatusOrdemServicoEnum.EM_FASE_EXECUCAO && !os.dataInicio)
    )

  const todosItensAtribuidosExecucao = itens && itens.filter(el => !el.atribuidaExecucao).length == 0
  const todasDivergenciasAtribuidasCorrecao = itens && itens.filter(i => i.divergenciasPendentesCorrecao > 0 && !i.atribuidaCorrecao).length == 0

  const handleAtribuir = () => {
    setConfigModalAtribuirEquipeExecucao({
      idOrdemServico,
      idEmpresa: os.empresaExecutora.id,
      idContrato,
      valorTotal,
      execucoes: os?.execucoes || [],
      itens: itens.filter(el => !el.atribuidaExecucao),
      user: state.user
    })
  }

  const handleLiberarExecucao = () => {
    confirm('Você deseja liberar a execução dessa Ordem de Serviço?', async () => {
      try {
        showLoading()
        const res = await ordemServicoService.liberarExecucao(idOrdemServico)
        hideLoading()
        if (res.success) {
          toast('A Ordem de Serviço foi liberada com sucesso!')
          carregar()
          onChange && onChange()
        } else {
          toast('Erro ao liberar a Ordem de Serviço')
        }
      }
      catch (ex) {
        hideLoading()
        toast('Erro ao liberar a Ordem de Serviço')
      }
    })
  }

  const handleLiberarFiscalizacao = () => {
    confirm('Você deseja liberar a fiscalização dessa Ordem de Serviço?', async () => {
      await ordemServicoService.liberarFiscalizacao(idOrdemServico)
      carregar()
      onChange && onChange()
    })
  }

  const handleFinalizarSemaforica = () => {
    confirm('Você deseja finalizar essa Ordem de Serviço?', async () => {
      try {
        showLoading()
        const res = await ordemServicoService.finalizarSemaforica(idOrdemServico)
        hideLoading()
        if (res.success) {
          toast('A Ordem de Serviço foi finalizada com sucesso!')
          carregar()
          onChange && onChange()
        } else {
          toast('Erro ao finalizar a Ordem de Serviço')
        }
      } catch (ex) {
        hideLoading()
        toast('Erro ao finalizar a Ordem de Serviço')
      }
    })
  }

  const handleAtribuirCorrecao = () => {
    setConfigModalAtribuirEquipeCorrecao({
      idOrdemServico,
      idEmpresa: os.empresaExecutora.id,
      idContrato,
      valorTotal,
      correcoes: os?.correcoes || [],
      itens: itens.filter(i => i.divergenciasPendentesCorrecao > 0 && !i.atribuidaCorrecao),
      user: state.user
    })
  }

  const handleAlterarPrioridade = () => {
    setConfigModalAlterarPrioridade({
      idOrdemServico,
      prioridade: os?.prioridade
    })
  }

  const handleSelecionarExecutor = () => {
    setConfigModalSelecionarExecutor({
      idOrdemServico,
      idContrato,

      valorTotal,
      user: state.user
    })
  }

  const handleRegistroClick = (tipoHistorico, idItemRelacionado) => {
    if (tipoHistorico == TipoHistoricoOrdemServicoEnum.MOVIMENTACAO) {
      const item = ordemServicoService.getItemById(idOrdemServico, idItemRelacionado)
      setConfigModalDetalhes({
        idOrdemServico,
        idItem: item.id
      })
    } else if (tipoHistorico == TipoHistoricoOrdemServicoEnum.FISCALIZACAO) {
      const fiscalizacao = ordemServicoService.getFiscalizacaoById(idOrdemServico, idItemRelacionado)
      setConfigModalDetalhes({
        idOrdemServico,
        idItem: fiscalizacao.item.id
      })
    } else if (tipoHistorico == TipoHistoricoOrdemServicoEnum.CORRECAO) {
      const item = ordemServicoService.getItemById(idOrdemServico, idItemRelacionado)
      setConfigModalDetalhes({
        idOrdemServico,
        idItem: item.id
      })
    } else {
      alert({
        text: 'Tipo não tratado ainda'
      })
    }
  }

  const handleLiberarFiscalizacaoCorrecao = () => {
    confirm('Você deseja liberar as correções dessa Ordem de Serviço para Fiscalização?', async () => {
      await ordemServicoService.liberarFiscalizacaoCorrecao(idOrdemServico)
      carregar()
      onChange && onChange()
    })
  }

  return (
    <>
      <div className="movimentacoes">
        <div className="text-center d-flex justify-content-center mb-4">
          <div className="border rounded py-2 px-5">
            <strong>Status:</strong> {getStatusOrdemServicoDescription(idStatus)}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {podeAlterarPrioridade && (
            <Button color="primary" outline onClick={handleAlterarPrioridade}>Alterar Prioridade</Button>
          )}
          {(idStatus == StatusOrdemServicoEnum.PENDENTE && acoesUsuario.includes('os.liberar_execucao')) && (
            <Button color="primary" onClick={handleLiberarExecucao}>
              {consorcioEmpresa == 'E' ? 'Liberar para Empresa Executora' : 'Liberar para seleção da Empresa Executora'}
            </Button>
          )}
          {(idStatus == StatusOrdemServicoEnum.AGUARDANDO_SELECAO_EMPRESA_EXECUTORA && acoesUsuario.includes('os.atribuir_empresa_executora')) && (
            !os.empresaLiderConsorcio ? (
              <div className="alert alert-secondary">O consórcio responsável por este contrato não tem um líder definido</div>
            ) : (
              state.user.empresa.id == os.empresaLiderConsorcio.id && (
                <Button color="primary" onClick={handleSelecionarExecutor}>Selecionar Empresa</Button>
              )
            )
          )}
          {(
            idStatus == StatusOrdemServicoEnum.EM_FASE_EXECUCAO &&
            acoesUsuario.includes('os.atribuir_equipe') &&
            os &&
            state.user.empresa.id == os.empresaExecutora.id &&
            !todosItensAtribuidosExecucao
          ) && (
              <>
                {os?.contrato_tipoContrato == TipoContratoEnum.SEMAFORICO ? (
                  <>Essa Ordem de Serviço não pode ser atribuída, a equipe deve assumir a execução</>
                ) : (
                  <Button color="primary" onClick={handleAtribuir}>Atribuir</Button>
                )}
              </>
            )}
          {(
            idStatus == StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_EXECUCAO &&
            acoesUsuario.includes(os?.contrato_tipoContrato == TipoContratoEnum.SEMAFORICO ? 'os.gerenciar' : 'os.liberar_fiscalizacao') &&
            state.user.empresa?.id == os.empresaExecutora?.id
          ) && (
            <>
              {os?.contrato_tipoContrato == TipoContratoEnum.SEMAFORICO ? (
                acoesUsuario.includes('os.gerenciar') && (
                  <Button color="primary" onClick={handleFinalizarSemaforica}>Finalizar</Button>
                )
              ) : (
                acoesUsuario.includes('os.liberar_fiscalizacao') && (
                  <Button color="primary" onClick={handleLiberarFiscalizacao}>Liberar para Fiscalização</Button>
                )
              )}
            </>
          )}
          {(
            idStatus == StatusOrdemServicoEnum.EM_FASE_CORRECAO &&
            acoesUsuario.includes('os.atribuir_equipe') &&
            state.user.empresa.id == os.empresaExecutora.id &&
            !todasDivergenciasAtribuidasCorrecao
          ) && (
              <>
                <Button color="primary" onClick={handleAtribuirCorrecao}>Atribuir</Button>
              </>
            )}
          {(idStatus == StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_CORRECAO && acoesUsuario.includes('os.liberar_fiscalizacao_correcao') && state.user.empresa.id == os.empresaExecutora.id) && (
            <Button color="primary" onClick={handleLiberarFiscalizacaoCorrecao}>Liberar Correção para Fiscalização</Button>
          )}
        </div>
        <h2>Histórico</h2>
        <div className="d-flex flex-column gap-10px">
          {items.sort((a, b) => compareDate(b.data, a.data)).map(el => (
            <Registro key={el.id} item={el} onClickDetalhes={() => handleRegistroClick(el.tipoHistorico, el.idItemRelacionado)} />
          ))}
        </div>
      </div>

      <ModalSelecionarExecutor
        config={configModalSelecionarExecutor}
        onClosed={() => setConfigModalSelecionarExecutor()}
        onChange={() => {
          carregar()
          onChange && onChange()
        }}
      />

      <ModalAtribuirEquipeExecucao
        config={configModalAtribuirEquipeExecucao}
        onClosed={() => setConfigModalAtribuirEquipeExecucao()}
        onChange={() => {
          carregar()
          onChange && onChange()
        }}
      />

      <ModalAtribuirEquipeCorrecao
        config={configModalAtribuirEquipeCorrecao}
        onClosed={() => setConfigModalAtribuirEquipeCorrecao()}
        onChange={() => {
          carregar()
          onChange && onChange()
        }}
      />

      <ModalAlterarPrioridade
        config={configModalAlterarPrioridade}
        onClosed={() => setConfigModalAlterarPrioridade()}
        onChange={() => {
          carregar()
          onChange && onChange()
        }}
      />

      <ModalDetalhes
        config={configModalDetalhes}
        onClosed={() => setConfigModalDetalhes()}
      />
    </>
  )
}